{
  "main": "Principal",
  "my_library": "Mi biblioteca",
  "node_names": {
    "Folder": "Carpeta",
    "PersonalMappingLibrary": "Mi espacio de trabajo",
    "MappingLibrary": "Espacio de trabajo en equipo",
    "Map": "Planifica",
    "Layer": "Capa",
    "MapObject": "Objeto",
    "Schedule": "Cronograma",
    "ScheduleVersion": "Cronograma"
  },
  "static_library_names": {
    "recently_viewed": "Visto recientemente",
    "favourites": "Favoritos"
  },
  "static_library_empty": {
    "recently_viewed": "Los planes que abriste recientemente se mostrarán aquí",
    "favourites": "Los planes y carpetas que hayas marcado como favoritos se mostrarán aquí para que puedas acceder a ellos fácilmente"
  },
  "static_library_empty_button": {
    "recently_viewed": "Empieza con tu primer plan",
    "favourites": "Explore los planes del proyecto"
  },
  "node_content": {
    "last_activity": "Actividad más reciente {{ latestActivityDate }}",
    "created": "Creado {{ createdAt }}",
    "last_viewed": "Visto por última vez {{ viewedAt }}"
  },
  "create_node": {
    "saveInFolder": "Guardar en la carpeta",
    "title": "Crea {{ nodeName }}",
    "fieldLabel": "Nombre {{ nodeName }}",
    "creating": "Creando {{ nodeName }}",
    "maxInputChars": "El nombre no debe tener más de 500 caracteres"
  },
  "permissions": "Edita los permisos de {{ nodeName }}",
  "update_node": {
    "title": "Cambie el nombre de {{ nodeName }}",
    "description": "Este {{ nodeName }} se actualizará para todos.",
    "updating": "Cambiando el nombre de {{ nodeName }}"
  },
  "delete_node": {
    "singular_title": "Eliminar un {{ nodeType }}",
    "singular_description": "Al eliminar este {{ nodeType }} también se eliminará todo el contenido.",
    "singular_confirm_button": "Eliminar {{ nodeType }}",
    "multi_title": "Eliminar {{ count }} artículos",
    "multi_description": "Al eliminar estos elementos, también se eliminará todo el contenido.",
    "multi_confirm_button": "Eliminar elementos"
  },
  "overflow": {
    "description": "Haz clic para abrir las opciones de {{ nodeName }}",
    "rename": "Cambia el nombre de {{ nodeName }}",
    "delete": "Eliminar {{ nodeName }}",
    "permissions": "Cambia los permisos de {{ nodeName }}"
  },
  "empty_node": "{{ nodeName }} está vacío",
  "folder_browser_view": {
    "while_in": {
      "list": "Ver como mosaicos",
      "tile": "Ver como lista"
    }
  },
  "sort": {
    "folder_first_asc": "La carpeta es lo primero (A-Z)",
    "name_asc": "Nombre (A-Z)"
  },
  "saveLocation": {
    "visibleYou": "Visible solo para ti",
    "visibleOtherTeamMembers": "Visible para otros miembros del equipo",
    "visibleWholeProject": "Visible para todos",
    "teamMembers": "miembros del equipo"
  },
  "hints": {
    "PersonalMappingLibrary": {
      "title": "Mi espacio de trabajo",
      "first_paragraph": "Los planes que crees aquí solo estarán disponibles para ti. \nUsa el botón «Crear un plan» para crear tu primer plan.",
      "second_paragraph": "Cuando estés listo para compartir los planes con tu equipo, puedes usar el «Espacio de trabajo en equipo»."
    },
    "MappingLibrary": {
      "title": "Espacio de trabajo en equipo",
      "first_paragraph": "Los planes creados aquí se comparten con todo tu equipo. Usa este espacio cuando colabores con otros miembros del equipo.",
      "second_paragraph": "También puedes organizar tus planes en carpetas, por ejemplo, para distintos departamentos."
    },
    "Map": {
      "title": "Aún no se ha agregado ninguna capa",
      "first_paragraph": "Comience por crear una capa para añadir objetos a su plan."
    },
    "Folder": {
      "title": "La carpeta está vacía",
      "first_paragraph": "Usa el botón «Crear un plan» que aparece arriba para agregar un plan aquí."
    },
    "ScheduleVersion": {
      "title": "{{ type }}",
      "first_paragraph": "Crea un {{ type }} para empezar a programar eventos."
    }
  },
  "hints_static_libraries": {
    "recently_viewed": {
      "title": "Visto recientemente",
      "first_paragraph": "Los planes que has visto recientemente aparecerán aquí."
    },
    "favourites": {
      "title": "Favoritos",
      "first_paragraph": "Tus planes y carpetas favoritos aparecerán aquí."
    }
  },
  "remove_node": {
    "singular_title": "Eliminar un {{ nodeType }}",
    "singular_description": "Al eliminar este {{ nodeType }} se eliminará del plan, pero seguirá existiendo en su plan original",
    "singular_confirm_button": "Eliminar {{ nodeType }}",
    "multi_title": "Eliminar {{ count }} artículos",
    "multi_description": "Al eliminar estos elementos, también se eliminará todo el contenido.\n \nLas capas importadas o vinculadas se eliminarán del plan, pero seguirán existiendo en su plan original.",
    "multi_confirm_button": "Eliminar elementos"
  },
  "cannot_drop_folder_into_its_sub_folder": "No se puede colocar una carpeta en su propia subcarpeta",
  "drag_and_drop": {
    "moving_multiple_items": "Moviendo {{ count }} elementos..."
  },
  "create_map_location": "Guardar en la carpeta"
}